import SimpleReactValidator from 'shared/utils/simple-react-validator';
import { toast } from 'react-hot-toast';
import { TAB_ASSEMBLY } from 'shared/product_tabs/tabs/tabType';
import { PRICE_SELECTED } from 'shared/data/quoteSteps';
import { changeTab } from 'shared/product_tabs/tabs/tabSlice';
import { updateValidatorFlag } from 'shared/product_tabs/tab_assembly/slice/assemblySlice';
import { selectAssemblyDataForValidate } from 'shared/product_tabs/tab_assembly/slice/selectors';

export const validator = new SimpleReactValidator({});

export const validate = () => (dispatch, getState) => {
  const { quoteStep, parametersChanged } = selectAssemblyDataForValidate(getState());

  let validateResult = true;

  if (quoteStep === PRICE_SELECTED) {
    if (!validator.allValid()) {
      validator.showMessages();
      dispatch(updateValidatorFlag());
      dispatch(changeTab(TAB_ASSEMBLY));
      // TODO: Translate
      toast.error('Please fix the errors in Assembly form');
      validateResult = false;
    } else if (parametersChanged) {
      toast('One or more parameters have changed. Please get a new Assembly quote', { type: 'warning' });
      dispatch(changeTab(TAB_ASSEMBLY));
      validateResult = false;
    }
  }

  return validateResult;
};
